import React, { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Aside from "./Aside/Aside";
import FailedPaymentStatus from "./Header/Components/FailedPaymentStatus";
import { Header } from "./Header/Header";
import { SW_LOGO } from "../../actions/api";
import { getInitialRoute, windowOpen } from "../../utils";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "../CommonComponents/AssetsHelper";


export function Layout(props) {
    const { children } = props;
    const [width, setWidth] = useState(window.innerWidth);
    const [sidebarMobileMenu, setSidebarMobileMenu] = useState(false);
    const [isActiveProAside, setProAsideMobileMenu] = useState(false);
    const [isFailedPayment, setFailedPayment] = useState(localStorage.getItem('is_failed_payment'));

    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const navigate = useNavigate();

    const isPlanExceeded = localStorage.getItem('plan_exceeded'); 
    
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [localStorage.getItem("is_failed_payment"), width]);


    const closeFailedPaymentStrip = () => {
        localStorage.removeItem('is_failed_payment');
        setFailedPayment(null);
    }

    const [isActiveMobileMenu, setActiveMobileMenu] = useState("false");
    const MobileTopbarMenu = () => {
        setActiveMobileMenu(!isActiveMobileMenu);
        if (isActiveMobileMenu) {
            document.body.classList.add('topbar-mobile-on');
        } else {
            document.body.classList.remove('topbar-mobile-on');
        }
    };

    const ActiveSidebarMobileMenu = () => {
        setSidebarMobileMenu(!sidebarMobileMenu);
    }

    const sidebarToggle = width < 992 ? sidebarMobileMenu : true


    return <>
        <div id="kt_header_mobile" className={`header-mobile ${getInitialRoute() == 'socialwalls' ? 'sw_theme' : ''} header-mobile-fixed f-between bg-white position-fixed top-0 end-0 start-0 px-3 border-bottom`}>
            <Link to={`/walls`} className="mobile-brand-logo">
                <img className="img-fluid" src={SW_LOGO} width={'150'} height={'30'} />
            </Link>
            <div className="d-flex align-items-center">
                <Button variant="" className={`brand-toggle btn-sm border-0 p-0 toggle_icon_ custom_burger_icon`} id="kt_aside_mobile_toggle" onClick={ActiveSidebarMobileMenu}>
                    <FontAwesomeIcon type={'regular'} icon={'bars-sort'} iconClass={'fs-2 p-0'} />
                </Button>

                <Button variant="" className="border-0 p-0 ms-3 text-dark" id="kt_header_mobile_topbar_toggle" onClick={MobileTopbarMenu}>
                    <FontAwesomeIcon type={'duotone'} icon={'user '} iconClass={'fs-3'} />
                </Button>
            </div>
        </div>
        <div className={`d-flex flex-column flex-root ${getInitialRoute() == 'socialwalls' ? 'sw_theme' : ''} h-100`}>
            <div className="d-flex flex-column-fluid page flex-column">
                <Header isActiveProAside={isActiveProAside} isActiveProAsideFun={setProAsideMobileMenu} windowWidth={width} prefix={props.prefix} />
                {!props.hideAside && <Aside sidebarMobileMenu={sidebarToggle} windowWidth={width} prefix={props.prefix} />}
                <div className="wrapper" id="kt_wrapper">
                    {(userData.user?.isPaymentFailed && userData.user?.isPaymentFailedUrl && userData.user?.isPaymentTypeUser) ?
                        <div className="review-bnn position-relative">{userData.user?.isPaymentTypeUser == 1 ? '🚨Payment incomplete! Finish your upgrade to unlock full access to your plan.' : '🚨Payment failed! Update your billing info to keep your wall live.'}<span className="rbnn-clicable cursor-pointer text-decoration-underline" onClick={() => windowOpen(userData.user?.isPaymentFailedUrl, "_blank")}>{userData?.user?.isPaymentTypeUser == 1 ? ' Pay Now' : ' Update Now'}</span></div> : null}
                    <div className="content position-relative" id="kt_content">
                        {isFailedPayment && <FailedPaymentStatus closeFailedPaymentStrip={closeFailedPaymentStrip} />}
                        {isPlanExceeded && !window.location.pathname.includes('extrawallfeeds') && <div className="bg-dark py-3 d-flex flex-lg-column notification_bar plan_restriction" id="plan_restriction">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1 d-flex align-items-center flex-wrap flex-lg-nowrap justify-content-center">
                                        <div className="flex-grow-1">
                                            <p className="text-white me-md-2 mb-lg-0 mb-3">You have exceeded your plan's limit. To enjoy uninterrupted services, kindly revoke the additional walls/feed or upgrade your plan.</p>
                                        </div>
                                        <div className="d-flex">
                                            <a onClick={() => navigate(`/wall/extrawallfeeds`)} className="btn btn-primary btn-sm font-size-sm text-nowrap">Revoke</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    </>
}